export default __webpack_public_path__ + "static/media/nauLogo.2bd08369.png";